import React, { Component, Fragment } from "react";
import style from "./Table.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCompress, faExpand, faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons'

class TableColumn extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            isCollapsed: !!props.collapsed,
            sort: typeof props.sort === 'undefined' ? null : props.sort
        };

        if (this.state.isCollapsed) {
            props.onCollapse(this.props.index);
        }

        this.collapse.bind(this);
        this.expand.bind(this);
    }

    expand()
    {
        this.setState({isCollapsed: false});
        this.props.onExpand(this.props.index);
    }

    collapse()
    {
        this.setState({isCollapsed: true});
        this.props.onCollapse(this.props.index);
    }

    sort(isAscending)
    {
        this.setState({ sort: isAscending });
        this.props.onSort(this.props.index, isAscending);
    }

    isCollapsed()
    {
        return this.state.isCollapsed;
    }

    render()
    {
        let { isCollapsed, sort } = this.state;
        let { collapsable, sortable } = this.props;

        return <th>
            { isCollapsed ? '' : this.props.children }
             <div className={style.headerActions}>
                 {
                     isCollapsed
                     ? <FontAwesomeIcon icon={faExpand} onClick={() => this.expand()} />
                     :
                         <Fragment>
                             {
                                 sortable === false
                                     ? ''
                                     : null === sort
                                         ? <FontAwesomeIcon icon={faSort} onClick={() => this.sort(true)}/>
                                         : true === sort
                                            ? <FontAwesomeIcon icon={faSortUp} onClick={() => this.sort(false)}/>
                                            : <FontAwesomeIcon icon={faSortDown} onClick={() => this.sort(null)}/>
                             }
                             {
                                 collapsable === false
                                     ? ''
                                     : <FontAwesomeIcon icon={faCompress} onClick={() => this.collapse()}/>
                             }
                         </Fragment>
                 }
             </div>
        </th>
    }
}

export default TableColumn;
